import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  BadgeComponent,
  ButtonComponent,
  DividerComponent,
  GroupComponent,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  MessageComponent,
} from '@recruitee/user-interface';

import { InfoboxComponent } from './infobox.component';

@NgModule({
  imports: [
    BadgeComponent,
    ButtonComponent,
    CommonModule,
    DividerComponent,
    GroupComponent,
    HeadingComponent,
    IconButtonComponent,
    IconComponent,
    MessageComponent,
    InfoboxComponent,
  ],
  exports: [InfoboxComponent],
})
export class InfoboxModule {}

export { InfoboxComponent };
